<template>
  <v-app>
    <v-app-bar
      app
      clipped-left
      clipped-right
      color="primary"
    >
      <v-toolbar-title>ResMan UI Library</v-toolbar-title>
    </v-app-bar>

    <v-navigation-drawer
      app
      clipped
      permanent
      disable-route-watcher
      disable-resize-watcher
    >
      <v-list dense>
        <v-list-item
          :to="{name: 'home'}"
          exact
        >
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          :to="{name: 'guidelines'}"
          exact
        >
          <v-list-item-content>
            <v-list-item-title>Guidelines</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider />

        <v-list-group>
          <template #activator>
            <v-list-item-content>
              <v-list-item-title>Themes</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="themeName in themeNames"
            :to="{name: 'theme', params: {themeName}}"
            exact
            class="pl-8"
          >
            <v-list-item-content>
              <v-list-item-title>{{ themeName }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group>
          <template #activator>
            <v-list-item-content>
              <v-list-item-title>Components</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="componentName in componentNames"
            :key="componentName"
            :to="{name: 'component', params: {componentName}}"
            exact
            class="pl-8"
          >
            <v-list-item-content>
              <v-list-item-title>{{ componentName }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import * as Themes from '@resman/ui/themes';
import * as Components from '@resman/ui/components';

export default {
  computed: {
    themeNames() {
      return Object.keys(Themes);
    },
    componentNames() {
      return Object.keys(Components);
    },
  },
};
</script>

<style lang="scss">
.theme--light {
  color: rgba(0,0,0,0.7) !important;
}
</style>
